"use client";

import Footer from "@/components/common/footer";
import { usePathname } from "next/navigation";
import React, { useMemo } from "react";

export const FooterLayout = ({ noFooters }) => {
  const pathname = usePathname();

  const outletRender = useMemo(() => {
    let render = true;
    noFooters?.map((item) => {
      if (pathname.includes(item)) {
        render = false;
      }
    });

    if (render) {
      return <Footer />;
    }
  }, [pathname, noFooters]);
  return outletRender;
};
